"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _eq = _interopRequireDefault(require("lodash/fp/eq"));
var _classnames = _interopRequireDefault(require("classnames"));
var _SmallSpinnerSVG = _interopRequireDefault(require("./SmallSpinnerSVG"));
var _LargeSpinnerSVG = _interopRequireDefault(require("./LargeSpinnerSVG"));
var _excluded = ["size", "type"];
var Spinner = function Spinner(_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'lg' : _ref$size,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = (0, _classnames["default"])('spinner', {
    'spinner-super': (0, _eq["default"])('lg')(size) && (0, _eq["default"])('super')(type),
    'spinner-primary': (0, _eq["default"])('lg')(size) && (0, _eq["default"])('primary')(type),
    'spinner-sm': (0, _eq["default"])('sm')(size),
    'spinner-dark': (0, _eq["default"])('sm')(size) && (0, _eq["default"])('default')(type),
    'spinner-light': (0, _eq["default"])('sm')(size) && (0, _eq["default"])('primary')(type)
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "spinner",
    ref: ref,
    className: classes
  }, (0, _eq["default"])('sm')(size) ? /*#__PURE__*/_react["default"].createElement(_SmallSpinnerSVG["default"], rest) : /*#__PURE__*/_react["default"].createElement(_LargeSpinnerSVG["default"], rest));
};
var SpinnerWithRef = /*#__PURE__*/_react["default"].forwardRef(Spinner);
var _default = exports["default"] = SpinnerWithRef;